import { IAriaLabels } from '@models/IAriaLabels';
import useAriaLabelsStore from '@state/AriaLabelsStore';
import { useEffect } from 'react';

interface Props {
  readonly accessibility: IAriaLabels;
}

// This component is added to every page, this component is handy for dispatching global state and avoid prop drilling
const GlobalSettings = ({ accessibility }: Props) => {
  const { setAriaLabels } = useAriaLabelsStore((state) => ({
    setAriaLabels: state.setAriaLabels,
  }));

  useEffect(() => {
    setAriaLabels(accessibility);
  }, [accessibility, setAriaLabels]);

  return null;
};

export default GlobalSettings;
